import { country_state_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCountryStateEnum = (enumValue: country_state_enum) => {
  switch (enumValue) {
    case country_state_enum.AT_BURGENLAND:
      return <Trans i18nKey="Enum_CountryStateEnum-AT_BURGENLAND" />;
    case country_state_enum.AT_CARINTHIA:
      return <Trans i18nKey="Enum_CountryStateEnum-AT_CARINTHIA" />;
    case country_state_enum.AT_LOWER_AUSTRIA:
      return <Trans i18nKey="Enum_CountryStateEnum-AT_LOWER_AUSTRIA" />;
    case country_state_enum.AT_SALZBURG:
      return <Trans i18nKey="Enum_CountryStateEnum-AT_SALZBURG" />;
    case country_state_enum.AT_STYRIA:
      return <Trans i18nKey="Enum_CountryStateEnum-AT_STYRIA" />;
    case country_state_enum.AT_TYROL:
      return <Trans i18nKey="Enum_CountryStateEnum-AT_TYROL" />;
    case country_state_enum.AT_UPPER_AUSTRIA:
      return <Trans i18nKey="Enum_CountryStateEnum-AT_UPPER_AUSTRIA" />;
    case country_state_enum.AT_VIENNA:
      return <Trans i18nKey="Enum_CountryStateEnum-AT_VIENNA" />;
    case country_state_enum.AT_VORARLBERG:
      return <Trans i18nKey="Enum_CountryStateEnum-AT_VORARLBERG" />;
    case country_state_enum.BE_BRUSSELS:
      return <Trans i18nKey="Enum_CountryStateEnum-BE_BRUSSELS" />;
    case country_state_enum.BE_FLANDERS:
      return <Trans i18nKey="Enum_CountryStateEnum-BE_FLANDERS" />;
    case country_state_enum.BE_WALLONIA:
      return <Trans i18nKey="Enum_CountryStateEnum-BE_WALLONIA" />;
    case country_state_enum.CZ_JIHOCESKY:
      return <Trans i18nKey="Enum_CountryStateEnum-CZ_JIHOCESKY" />;
    case country_state_enum.CZ_JIHOMORAVSKY:
      return <Trans i18nKey="Enum_CountryStateEnum-CZ_JIHOMORAVSKY" />;
    case country_state_enum.CZ_KARLOVARSKY:
      return <Trans i18nKey="Enum_CountryStateEnum-CZ_KARLOVARSKY" />;
    case country_state_enum.CZ_KRALOVEHRADECKY:
      return <Trans i18nKey="Enum_CountryStateEnum-CZ_KRALOVEHRADECKY" />;
    case country_state_enum.CZ_LIBERECKY:
      return <Trans i18nKey="Enum_CountryStateEnum-CZ_LIBERECKY" />;
    case country_state_enum.CZ_MORAVSKOSLEZSKY:
      return <Trans i18nKey="Enum_CountryStateEnum-CZ_MORAVSKOSLEZSKY" />;
    case country_state_enum.CZ_OLOMOUCKY:
      return <Trans i18nKey="Enum_CountryStateEnum-CZ_OLOMOUCKY" />;
    case country_state_enum.CZ_PARDUBICKY:
      return <Trans i18nKey="Enum_CountryStateEnum-CZ_PARDUBICKY" />;
    case country_state_enum.CZ_PLZENSKY:
      return <Trans i18nKey="Enum_CountryStateEnum-CZ_PLZENSKY" />;
    case country_state_enum.CZ_PRAHA:
      return <Trans i18nKey="Enum_CountryStateEnum-CZ_PRAHA" />;
    case country_state_enum.CZ_STREDOCESKY:
      return <Trans i18nKey="Enum_CountryStateEnum-CZ_STREDOCESKY" />;
    case country_state_enum.CZ_USTECKY:
      return <Trans i18nKey="Enum_CountryStateEnum-CZ_USTECKY" />;
    case country_state_enum.CZ_VYSOCINA:
      return <Trans i18nKey="Enum_CountryStateEnum-CZ_VYSOCINA" />;
    case country_state_enum.CZ_ZLINSKY:
      return <Trans i18nKey="Enum_CountryStateEnum-CZ_ZLINSKY" />;
    case country_state_enum.DE_BADEN_WUERTTEMBERG:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_BADEN_WUERTTEMBERG" />;
    case country_state_enum.DE_BAYERN:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_BAYERN" />;
    case country_state_enum.DE_BERLIN:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_BERLIN" />;
    case country_state_enum.DE_BRANDENBURG:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_BRANDENBURG" />;
    case country_state_enum.DE_BREMEN:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_BREMEN" />;
    case country_state_enum.DE_HAMBURG:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_HAMBURG" />;
    case country_state_enum.DE_HESSEN:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_HESSEN" />;
    case country_state_enum.DE_MECKLENBURG_VORPOMMERN:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_MECKLENBURG_VORPOMMERN" />;
    case country_state_enum.DE_NIEDERSACHSEN:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_NIEDERSACHSEN" />;
    case country_state_enum.DE_NORDRHEIN_WESTFALEN:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_NORDRHEIN_WESTFALEN" />;
    case country_state_enum.DE_RHEINLAND_PFALZ:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_RHEINLAND_PFALZ" />;
    case country_state_enum.DE_SAARLAND:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_SAARLAND" />;
    case country_state_enum.DE_SACHSEN:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_SACHSEN" />;
    case country_state_enum.DE_SACHSEN_ANHALT:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_SACHSEN_ANHALT" />;
    case country_state_enum.DE_SCHLESWIG_HOLSTEIN:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_SCHLESWIG_HOLSTEIN" />;
    case country_state_enum.DE_THUERINGEN:
      return <Trans i18nKey="Enum_CountryStateEnum-DE_THUERINGEN" />;
    case country_state_enum.FR_AUVERGNE_RHONE_ALPES:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_AUVERGNE_RHONE_ALPES" />;
    case country_state_enum.FR_BOURGOGNE_FRANCHE_COMTE:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_BOURGOGNE_FRANCHE_COMTE" />;
    case country_state_enum.FR_BRETAGNE:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_BRETAGNE" />;
    case country_state_enum.FR_CENTRE_VAL_DE_LOIRE:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_CENTRE_VAL_DE_LOIRE" />;
    case country_state_enum.FR_CORSE:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_CORSE" />;
    case country_state_enum.FR_GRAND_EST:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_GRAND_EST" />;
    case country_state_enum.FR_GUADELOUPE:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_GUADELOUPE" />;
    case country_state_enum.FR_GUYANE:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_GUYANE" />;
    case country_state_enum.FR_HAUTS_DE_FRANCE:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_HAUTS_DE_FRANCE" />;
    case country_state_enum.FR_ILE_DE_FRANCE:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_ILE_DE_FRANCE" />;
    case country_state_enum.FR_LA_REUNION:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_LA_REUNION" />;
    case country_state_enum.FR_MARTINIQUE:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_MARTINIQUE" />;
    case country_state_enum.FR_MAYOTTE:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_MAYOTTE" />;
    case country_state_enum.FR_NORMANDIE:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_NORMANDIE" />;
    case country_state_enum.FR_NOUVELLE_AQUITAINE:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_NOUVELLE_AQUITAINE" />;
    case country_state_enum.FR_OCCITANIE:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_OCCITANIE" />;
    case country_state_enum.FR_PAYS_DE_LA_LOIRE:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_PAYS_DE_LA_LOIRE" />;
    case country_state_enum.FR_PROVENCE_ALPES_COTE_D_AZUR:
      return <Trans i18nKey="Enum_CountryStateEnum-FR_PROVENCE_ALPES_COTE_D_AZUR" />;
    case country_state_enum.NL_DRENTHE:
      return <Trans i18nKey="Enum_CountryStateEnum-NL_DRENTHE" />;
    case country_state_enum.NL_FLEVOLAND:
      return <Trans i18nKey="Enum_CountryStateEnum-NL_FLEVOLAND" />;
    case country_state_enum.NL_FRIESLAND:
      return <Trans i18nKey="Enum_CountryStateEnum-NL_FRIESLAND" />;
    case country_state_enum.NL_GELDERLAND:
      return <Trans i18nKey="Enum_CountryStateEnum-NL_GELDERLAND" />;
    case country_state_enum.NL_GRONINGEN:
      return <Trans i18nKey="Enum_CountryStateEnum-NL_GRONINGEN" />;
    case country_state_enum.NL_LIMBURG:
      return <Trans i18nKey="Enum_CountryStateEnum-NL_LIMBURG" />;
    case country_state_enum.NL_NOORD_BRABANT:
      return <Trans i18nKey="Enum_CountryStateEnum-NL_NOORD_BRABANT" />;
    case country_state_enum.NL_NOORD_HOLLAND:
      return <Trans i18nKey="Enum_CountryStateEnum-NL_NOORD_HOLLAND" />;
    case country_state_enum.NL_OVERIJSSEL:
      return <Trans i18nKey="Enum_CountryStateEnum-NL_OVERIJSSEL" />;
    case country_state_enum.NL_UTRECHT:
      return <Trans i18nKey="Enum_CountryStateEnum-NL_UTRECHT" />;
    case country_state_enum.NL_ZEELAND:
      return <Trans i18nKey="Enum_CountryStateEnum-NL_ZEELAND" />;
    case country_state_enum.NL_ZUID_HOLLAND:
      return <Trans i18nKey="Enum_CountryStateEnum-NL_ZUID_HOLLAND" />;
    case country_state_enum.PL_GREATER_POLAND:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_GREATER_POLAND" />;
    case country_state_enum.PL_HOLY_CROSS:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_HOLY_CROSS" />;
    case country_state_enum.PL_KUYAVIAN_POMERANIAN:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_KUYAVIAN_POMERANIAN" />;
    case country_state_enum.PL_LESSER_POLAND:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_LESSER_POLAND" />;
    case country_state_enum.PL_LODZ:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_LODZ" />;
    case country_state_enum.PL_LOWER_SILESIAN:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_LOWER_SILESIAN" />;
    case country_state_enum.PL_LUBLIN:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_LUBLIN" />;
    case country_state_enum.PL_LUBUSZ:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_LUBUSZ" />;
    case country_state_enum.PL_MASOVIAN:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_MASOVIAN" />;
    case country_state_enum.PL_OPOLE:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_OPOLE" />;
    case country_state_enum.PL_PODLASKIE:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_PODLASKIE" />;
    case country_state_enum.PL_POMERANIAN:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_POMERANIAN" />;
    case country_state_enum.PL_SILESIAN:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_SILESIAN" />;
    case country_state_enum.PL_SUBCARPATHIAN:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_SUBCARPATHIAN" />;
    case country_state_enum.PL_WARMIAN_MASURIAN:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_WARMIAN_MASURIAN" />;
    case country_state_enum.PL_WEST_POMERANIAN:
      return <Trans i18nKey="Enum_CountryStateEnum-PL_WEST_POMERANIAN" />;
    case country_state_enum.UK_EAST_MIDLANDS:
      return <Trans i18nKey="Enum_CountryStateEnum-UK_EAST_MIDLANDS" />;
    case country_state_enum.UK_EAST_OF_ENGLAND:
      return <Trans i18nKey="Enum_CountryStateEnum-UK_EAST_OF_ENGLAND" />;
    case country_state_enum.UK_LONDON:
      return <Trans i18nKey="Enum_CountryStateEnum-UK_LONDON" />;
    case country_state_enum.UK_NORTHERN_IRELAND:
      return <Trans i18nKey="Enum_CountryStateEnum-UK_NORTHERN_IRELAND" />;
    case country_state_enum.UK_NORTH_EAST:
      return <Trans i18nKey="Enum_CountryStateEnum-UK_NORTH_EAST" />;
    case country_state_enum.UK_NORTH_WEST:
      return <Trans i18nKey="Enum_CountryStateEnum-UK_NORTH_WEST" />;
    case country_state_enum.UK_SCOTLAND:
      return <Trans i18nKey="Enum_CountryStateEnum-UK_SCOTLAND" />;
    case country_state_enum.UK_SOUTH_EAST:
      return <Trans i18nKey="Enum_CountryStateEnum-UK_SOUTH_EAST" />;
    case country_state_enum.UK_SOUTH_WEST:
      return <Trans i18nKey="Enum_CountryStateEnum-UK_SOUTH_WEST" />;
    case country_state_enum.UK_WALES:
      return <Trans i18nKey="Enum_CountryStateEnum-UK_WALES" />;
    case country_state_enum.UK_WEST_MIDLANDS:
      return <Trans i18nKey="Enum_CountryStateEnum-UK_WEST_MIDLANDS" />;
    case country_state_enum.UK_YORKSHIRE_AND_THE_HUMBER:
      return <Trans i18nKey="Enum_CountryStateEnum-UK_YORKSHIRE_AND_THE_HUMBER" />;
    case country_state_enum.UNKNOWN:
      return <Trans i18nKey="Enum_CountryStateEnum-UNKNOWN" />;
  }
};

export const translateCountryStateEnum_dynamic = (enumValue: country_state_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case country_state_enum.AT_BURGENLAND:
      return t('Enum_CountryStateEnum-AT_BURGENLAND');
    case country_state_enum.AT_CARINTHIA:
      return t('Enum_CountryStateEnum-AT_CARINTHIA');
    case country_state_enum.AT_LOWER_AUSTRIA:
      return t('Enum_CountryStateEnum-AT_LOWER_AUSTRIA');
    case country_state_enum.AT_SALZBURG:
      return t('Enum_CountryStateEnum-AT_SALZBURG');
    case country_state_enum.AT_STYRIA:
      return t('Enum_CountryStateEnum-AT_STYRIA');
    case country_state_enum.AT_TYROL:
      return t('Enum_CountryStateEnum-AT_TYROL');
    case country_state_enum.AT_UPPER_AUSTRIA:
      return t('Enum_CountryStateEnum-AT_UPPER_AUSTRIA');
    case country_state_enum.AT_VIENNA:
      return t('Enum_CountryStateEnum-AT_VIENNA');
    case country_state_enum.AT_VORARLBERG:
      return t('Enum_CountryStateEnum-AT_VORARLBERG');
    case country_state_enum.BE_BRUSSELS:
      return t('Enum_CountryStateEnum-BE_BRUSSELS');
    case country_state_enum.BE_FLANDERS:
      return t('Enum_CountryStateEnum-BE_FLANDERS');
    case country_state_enum.BE_WALLONIA:
      return t('Enum_CountryStateEnum-BE_WALLONIA');
    case country_state_enum.CZ_JIHOCESKY:
      return t('Enum_CountryStateEnum-CZ_JIHOCESKY');
    case country_state_enum.CZ_JIHOMORAVSKY:
      return t('Enum_CountryStateEnum-CZ_JIHOMORAVSKY');
    case country_state_enum.CZ_KARLOVARSKY:
      return t('Enum_CountryStateEnum-CZ_KARLOVARSKY');
    case country_state_enum.CZ_KRALOVEHRADECKY:
      return t('Enum_CountryStateEnum-CZ_KRALOVEHRADECKY');
    case country_state_enum.CZ_LIBERECKY:
      return t('Enum_CountryStateEnum-CZ_LIBERECKY');
    case country_state_enum.CZ_MORAVSKOSLEZSKY:
      return t('Enum_CountryStateEnum-CZ_MORAVSKOSLEZSKY');
    case country_state_enum.CZ_OLOMOUCKY:
      return t('Enum_CountryStateEnum-CZ_OLOMOUCKY');
    case country_state_enum.CZ_PARDUBICKY:
      return t('Enum_CountryStateEnum-CZ_PARDUBICKY');
    case country_state_enum.CZ_PLZENSKY:
      return t('Enum_CountryStateEnum-CZ_PLZENSKY');
    case country_state_enum.CZ_PRAHA:
      return t('Enum_CountryStateEnum-CZ_PRAHA');
    case country_state_enum.CZ_STREDOCESKY:
      return t('Enum_CountryStateEnum-CZ_STREDOCESKY');
    case country_state_enum.CZ_USTECKY:
      return t('Enum_CountryStateEnum-CZ_USTECKY');
    case country_state_enum.CZ_VYSOCINA:
      return t('Enum_CountryStateEnum-CZ_VYSOCINA');
    case country_state_enum.CZ_ZLINSKY:
      return t('Enum_CountryStateEnum-CZ_ZLINSKY');
    case country_state_enum.DE_BADEN_WUERTTEMBERG:
      return t('Enum_CountryStateEnum-DE_BADEN_WUERTTEMBERG');
    case country_state_enum.DE_BAYERN:
      return t('Enum_CountryStateEnum-DE_BAYERN');
    case country_state_enum.DE_BERLIN:
      return t('Enum_CountryStateEnum-DE_BERLIN');
    case country_state_enum.DE_BRANDENBURG:
      return t('Enum_CountryStateEnum-DE_BRANDENBURG');
    case country_state_enum.DE_BREMEN:
      return t('Enum_CountryStateEnum-DE_BREMEN');
    case country_state_enum.DE_HAMBURG:
      return t('Enum_CountryStateEnum-DE_HAMBURG');
    case country_state_enum.DE_HESSEN:
      return t('Enum_CountryStateEnum-DE_HESSEN');
    case country_state_enum.DE_MECKLENBURG_VORPOMMERN:
      return t('Enum_CountryStateEnum-DE_MECKLENBURG_VORPOMMERN');
    case country_state_enum.DE_NIEDERSACHSEN:
      return t('Enum_CountryStateEnum-DE_NIEDERSACHSEN');
    case country_state_enum.DE_NORDRHEIN_WESTFALEN:
      return t('Enum_CountryStateEnum-DE_NORDRHEIN_WESTFALEN');
    case country_state_enum.DE_RHEINLAND_PFALZ:
      return t('Enum_CountryStateEnum-DE_RHEINLAND_PFALZ');
    case country_state_enum.DE_SAARLAND:
      return t('Enum_CountryStateEnum-DE_SAARLAND');
    case country_state_enum.DE_SACHSEN:
      return t('Enum_CountryStateEnum-DE_SACHSEN');
    case country_state_enum.DE_SACHSEN_ANHALT:
      return t('Enum_CountryStateEnum-DE_SACHSEN_ANHALT');
    case country_state_enum.DE_SCHLESWIG_HOLSTEIN:
      return t('Enum_CountryStateEnum-DE_SCHLESWIG_HOLSTEIN');
    case country_state_enum.DE_THUERINGEN:
      return t('Enum_CountryStateEnum-DE_THUERINGEN');
    case country_state_enum.FR_AUVERGNE_RHONE_ALPES:
      return t('Enum_CountryStateEnum-FR_AUVERGNE_RHONE_ALPES');
    case country_state_enum.FR_BOURGOGNE_FRANCHE_COMTE:
      return t('Enum_CountryStateEnum-FR_BOURGOGNE_FRANCHE_COMTE');
    case country_state_enum.FR_BRETAGNE:
      return t('Enum_CountryStateEnum-FR_BRETAGNE');
    case country_state_enum.FR_CENTRE_VAL_DE_LOIRE:
      return t('Enum_CountryStateEnum-FR_CENTRE_VAL_DE_LOIRE');
    case country_state_enum.FR_CORSE:
      return t('Enum_CountryStateEnum-FR_CORSE');
    case country_state_enum.FR_GRAND_EST:
      return t('Enum_CountryStateEnum-FR_GRAND_EST');
    case country_state_enum.FR_GUADELOUPE:
      return t('Enum_CountryStateEnum-FR_GUADELOUPE');
    case country_state_enum.FR_GUYANE:
      return t('Enum_CountryStateEnum-FR_GUYANE');
    case country_state_enum.FR_HAUTS_DE_FRANCE:
      return t('Enum_CountryStateEnum-FR_HAUTS_DE_FRANCE');
    case country_state_enum.FR_ILE_DE_FRANCE:
      return t('Enum_CountryStateEnum-FR_ILE_DE_FRANCE');
    case country_state_enum.FR_LA_REUNION:
      return t('Enum_CountryStateEnum-FR_LA_REUNION');
    case country_state_enum.FR_MARTINIQUE:
      return t('Enum_CountryStateEnum-FR_MARTINIQUE');
    case country_state_enum.FR_MAYOTTE:
      return t('Enum_CountryStateEnum-FR_MAYOTTE');
    case country_state_enum.FR_NORMANDIE:
      return t('Enum_CountryStateEnum-FR_NORMANDIE');
    case country_state_enum.FR_NOUVELLE_AQUITAINE:
      return t('Enum_CountryStateEnum-FR_NOUVELLE_AQUITAINE');
    case country_state_enum.FR_OCCITANIE:
      return t('Enum_CountryStateEnum-FR_OCCITANIE');
    case country_state_enum.FR_PAYS_DE_LA_LOIRE:
      return t('Enum_CountryStateEnum-FR_PAYS_DE_LA_LOIRE');
    case country_state_enum.FR_PROVENCE_ALPES_COTE_D_AZUR:
      return t('Enum_CountryStateEnum-FR_PROVENCE_ALPES_COTE_D_AZUR');
    case country_state_enum.NL_DRENTHE:
      return t('Enum_CountryStateEnum-NL_DRENTHE');
    case country_state_enum.NL_FLEVOLAND:
      return t('Enum_CountryStateEnum-NL_FLEVOLAND');
    case country_state_enum.NL_FRIESLAND:
      return t('Enum_CountryStateEnum-NL_FRIESLAND');
    case country_state_enum.NL_GELDERLAND:
      return t('Enum_CountryStateEnum-NL_GELDERLAND');
    case country_state_enum.NL_GRONINGEN:
      return t('Enum_CountryStateEnum-NL_GRONINGEN');
    case country_state_enum.NL_LIMBURG:
      return t('Enum_CountryStateEnum-NL_LIMBURG');
    case country_state_enum.NL_NOORD_BRABANT:
      return t('Enum_CountryStateEnum-NL_NOORD_BRABANT');
    case country_state_enum.NL_NOORD_HOLLAND:
      return t('Enum_CountryStateEnum-NL_NOORD_HOLLAND');
    case country_state_enum.NL_OVERIJSSEL:
      return t('Enum_CountryStateEnum-NL_OVERIJSSEL');
    case country_state_enum.NL_UTRECHT:
      return t('Enum_CountryStateEnum-NL_UTRECHT');
    case country_state_enum.NL_ZEELAND:
      return t('Enum_CountryStateEnum-NL_ZEELAND');
    case country_state_enum.NL_ZUID_HOLLAND:
      return t('Enum_CountryStateEnum-NL_ZUID_HOLLAND');
    case country_state_enum.PL_GREATER_POLAND:
      return t('Enum_CountryStateEnum-PL_GREATER_POLAND');
    case country_state_enum.PL_HOLY_CROSS:
      return t('Enum_CountryStateEnum-PL_HOLY_CROSS');
    case country_state_enum.PL_KUYAVIAN_POMERANIAN:
      return t('Enum_CountryStateEnum-PL_KUYAVIAN_POMERANIAN');
    case country_state_enum.PL_LESSER_POLAND:
      return t('Enum_CountryStateEnum-PL_LESSER_POLAND');
    case country_state_enum.PL_LODZ:
      return t('Enum_CountryStateEnum-PL_LODZ');
    case country_state_enum.PL_LOWER_SILESIAN:
      return t('Enum_CountryStateEnum-PL_LOWER_SILESIAN');
    case country_state_enum.PL_LUBLIN:
      return t('Enum_CountryStateEnum-PL_LUBLIN');
    case country_state_enum.PL_LUBUSZ:
      return t('Enum_CountryStateEnum-PL_LUBUSZ');
    case country_state_enum.PL_MASOVIAN:
      return t('Enum_CountryStateEnum-PL_MASOVIAN');
    case country_state_enum.PL_OPOLE:
      return t('Enum_CountryStateEnum-PL_OPOLE');
    case country_state_enum.PL_PODLASKIE:
      return t('Enum_CountryStateEnum-PL_PODLASKIE');
    case country_state_enum.PL_POMERANIAN:
      return t('Enum_CountryStateEnum-PL_POMERANIAN');
    case country_state_enum.PL_SILESIAN:
      return t('Enum_CountryStateEnum-PL_SILESIAN');
    case country_state_enum.PL_SUBCARPATHIAN:
      return t('Enum_CountryStateEnum-PL_SUBCARPATHIAN');
    case country_state_enum.PL_WARMIAN_MASURIAN:
      return t('Enum_CountryStateEnum-PL_WARMIAN_MASURIAN');
    case country_state_enum.PL_WEST_POMERANIAN:
      return t('Enum_CountryStateEnum-PL_WEST_POMERANIAN');
    case country_state_enum.UK_EAST_MIDLANDS:
      return t('Enum_CountryStateEnum-UK_EAST_MIDLANDS');
    case country_state_enum.UK_EAST_OF_ENGLAND:
      return t('Enum_CountryStateEnum-UK_EAST_OF_ENGLAND');
    case country_state_enum.UK_LONDON:
      return t('Enum_CountryStateEnum-UK_LONDON');
    case country_state_enum.UK_NORTHERN_IRELAND:
      return t('Enum_CountryStateEnum-UK_NORTHERN_IRELAND');
    case country_state_enum.UK_NORTH_EAST:
      return t('Enum_CountryStateEnum-UK_NORTH_EAST');
    case country_state_enum.UK_NORTH_WEST:
      return t('Enum_CountryStateEnum-UK_NORTH_WEST');
    case country_state_enum.UK_SCOTLAND:
      return t('Enum_CountryStateEnum-UK_SCOTLAND');
    case country_state_enum.UK_SOUTH_EAST:
      return t('Enum_CountryStateEnum-UK_SOUTH_EAST');
    case country_state_enum.UK_SOUTH_WEST:
      return t('Enum_CountryStateEnum-UK_SOUTH_WEST');
    case country_state_enum.UK_WALES:
      return t('Enum_CountryStateEnum-UK_WALES');
    case country_state_enum.UK_WEST_MIDLANDS:
      return t('Enum_CountryStateEnum-UK_WEST_MIDLANDS');
    case country_state_enum.UK_YORKSHIRE_AND_THE_HUMBER:
      return t('Enum_CountryStateEnum-UK_YORKSHIRE_AND_THE_HUMBER');
    case country_state_enum.UNKNOWN:
      return t('Enum_CountryStateEnum-UNKNOWN');
  }
};
